const Advisor = {
  CreateSupportCase: "Advisor.CreateSupportCase",
  CreateSupportCaseDescription: "Advisor.CreateSupportCaseDescription",
  DocumentationLog: "Advisor.DocumentationLog",
  AddToLog: "Advisor.AddToLog",
  SupportCase: "Advisor.SupportCase",
  DocumentationLogCreated: "Advisor.DocumentationLogCreated",
  SupportTicketWarning: "Advisor.SupportTicketWarning",
  SalaryReportType_0: "Advisor.SalaryReportType_0",
  SalaryReportType_1: "Advisor.SalaryReportType_1",
  LastConfirmed: "Advisor.LastConfirmed",
  UpdatedByCustomer: "Advisor.UpdatedByCustomer",
  Summation: "Advisor.Summation",
  Balance: "Advisor.Balance",
  SpecAndAdjustments: "Advisor.SpecAndAdjustments",
  Difference: "Advisor.Difference",
  MonthlyReports: "Advisor.MonthlyReports",
  GenerateMonthlyReport: "Advisor.GenerateMonthlyReport",
  GenerateMonthlyReportDescription: "Advisor.GenerateMonthlyReportDescription",
  MonthlyReportPeriod: "Advisor.MonthlyReportPeriod",
  MonthlyReportPeriodInvalid: "Advisor.MonthlyReportPeriodInvalid",
  MonthlyReportIteration: "Advisor.MonthlyReportIteration",
  MonthlyReportStatus_Generating: "Advisor.MonthlyReportStatus_Generating",
  MonthlyReportStatus_Draft: "Advisor.MonthlyReportStatus_Draft",
  MonthlyReportStatus_Approved: "Advisor.MonthlyReportStatus_Approved",
  MonthlyReportStatus_Failed: "Advisor.MonthlyReportStatus_Failed",
  MonthlyReportStatus_Unknown: "Advisor.MonthlyReportStatus_Unknown",
  Regenerate: "Advisor.Regenerate",
  RegenerateMonthlyReport: "Advisor.RegenerateMonthlyReport",
  RegenerateInstruction: "Advisor.RegenerateInstruction",
  RegenerateDescription: "Advisor.RegenerateDescription",
  EditMonthlyReport: "Advisor.EditMonthlyReport",
  MonthlyReportMarkdown: "Advisor.MonthlyReportMarkdown",
  ApproveAndShare: "Advisor.ApproveAndShare",
  ApproveMonthlyReportTitle: "Advisor.ApproveMonthlyReportTitle",
  ApproveMonthlyReportDescription: "Advisor.ApproveMonthlyReportDescription",
  ApproveMonthlyReportWarning: "Advisor.ApproveMonthlyReportWarning",
  UnpublishMonthlyReport: "Advisor.UnpublishMonthlyReport",
  MonthlyReportSharedBanner: "Advisor.MonthlyReportSharedBanner",
  MonthlyReportSharedBannerNoDate: "Advisor.MonthlyReportSharedBannerNoDate",
  MonthlyReportCustomerLink: "Advisor.MonthlyReportCustomerLink",
  MonthlyReportCustomerLinkHelp: "Advisor.MonthlyReportCustomerLinkHelp",
  Generate: "Advisor.Generate",
  MonthlyReportGenerating: "Advisor.MonthlyReportGenerating",
  MonthlyReportFailed: "Advisor.MonthlyReportFailed",
  RetryMonthlyReport: "Advisor.RetryMonthlyReport",
  MonthlyReportsLoadFailed: "Advisor.MonthlyReportsLoadFailed",
  MonthlyReportIterations: "Advisor.MonthlyReportIterations",
  MonthlyReportFirstDraft: "Advisor.MonthlyReportFirstDraft",
  MonthlyReportApproved: "Advisor.MonthlyReportApproved",
  MonthlyReportUnpublished: "Advisor.MonthlyReportUnpublished",
  UnpublishMonthlyReportTitle: "Advisor.UnpublishMonthlyReportTitle",
  UnpublishMonthlyReportDescription: "Advisor.UnpublishMonthlyReportDescription",
  MonthlyReportSharedAt: "Advisor.MonthlyReportSharedAt",
  MonthlyReportUpdatedAt: "Advisor.MonthlyReportUpdatedAt",
  MonthlyReportRegenerating: "Advisor.MonthlyReportRegenerating",
  MonthlyReportGeneratingStalled: "Advisor.MonthlyReportGeneratingStalled",
  EmailAddresses: "Advisor.EmailAddresses",
  EmailAddressesLoadFailed: "Advisor.EmailAddressesLoadFailed",
  SupplierInvoiceEmail: "Advisor.SupplierInvoiceEmail",
  DocumentEmail: "Advisor.DocumentEmail",
  SelfInvoiceEmail: "Advisor.SelfInvoiceEmail",
  DocumentEmailTooltip: "Advisor.DocumentEmailTooltip",
  SelfInvoiceEmailTooltip: "Advisor.SelfInvoiceEmailTooltip",
  VatReports: "Advisor.VatReports",
  VatReportsLoadFailed: "Advisor.VatReportsLoadFailed",
  VatReport: "Advisor.VatReport",
  VatReportsAvailabilityFailed: "Advisor.VatReportsAvailabilityFailed",
  VatReportsRetry: "Advisor.VatReportsRetry",
  VatReportAmountToPay: "Advisor.VatReportAmountToPay",
  VatReportAmountToPayBox: "Advisor.VatReportAmountToPayBox",
  VatReportToPay: "Advisor.VatReportToPay",
  VatReportToReceive: "Advisor.VatReportToReceive",
  VatReportOverdue: "Advisor.VatReportOverdue",
  VatReportOverdueMessage: "Advisor.VatReportOverdueMessage",
  VatReportVatPeriod: "Advisor.VatReportVatPeriod",
  VatReportCorrection: "Advisor.VatReportCorrection",
  VatReportVoucher: "Advisor.VatReportVoucher",
  VatReportAdditionalInformation: "Advisor.VatReportAdditionalInformation",
  VatReportDeclaration: "Advisor.VatReportDeclaration",
  VatReportStatus_Draft: "Advisor.VatReportStatus_Draft",
  VatReportStatus_Booked: "Advisor.VatReportStatus_Booked",
  VatReportStatus_BookedFiledByCustomer: "Advisor.VatReportStatus_BookedFiledByCustomer",
  VatReportStatus_AwaitingSignature: "Advisor.VatReportStatus_AwaitingSignature",
  VatReportStatus_Submitted: "Advisor.VatReportStatus_Submitted",
  VatReportStatus_ActionRequired: "Advisor.VatReportStatus_ActionRequired",
  VatReportStatus_BeingRemoved: "Advisor.VatReportStatus_BeingRemoved",
  VatReportStatus_Unknown: "Advisor.VatReportStatus_Unknown",
  VatReportActionReason_UploadFailed: "Advisor.VatReportActionReason_UploadFailed",
  VatReportActionReason_Rejected: "Advisor.VatReportActionReason_Rejected",
  VatReportActionReason_AuthorizationFailure: "Advisor.VatReportActionReason_AuthorizationFailure",
  VatReportActionReason_MissingPeriod: "Advisor.VatReportActionReason_MissingPeriod",
  VatReportActionReason_StoppedByValidation: "Advisor.VatReportActionReason_StoppedByValidation",
  VatReportLifecycle_0: "Advisor.VatReportLifecycle_0",
  VatReportLifecycle_1: "Advisor.VatReportLifecycle_1",
  VatReportLifecycle_2: "Advisor.VatReportLifecycle_2",
  VatReportLifecycle_3: "Advisor.VatReportLifecycle_3",
  VatReportSection_A: "Advisor.VatReportSection_A",
  VatReportSection_B: "Advisor.VatReportSection_B",
  VatReportSection_C: "Advisor.VatReportSection_C",
  VatReportSection_D: "Advisor.VatReportSection_D",
  VatReportSection_H: "Advisor.VatReportSection_H",
  VatReportSection_I: "Advisor.VatReportSection_I",
  VatReportSection_E: "Advisor.VatReportSection_E",
  VatReportSection_F: "Advisor.VatReportSection_F",
  VatReportSection_G: "Advisor.VatReportSection_G",
  CompanyInstruction: "Advisor.CompanyInstruction",
  CompanyInstructionLabel: "Advisor.CompanyInstructionLabel",
  CompanyInstructionDescription: "Advisor.CompanyInstructionDescription",
  CompanyInstructionSaving: "Advisor.CompanyInstructionSaving",
  CompanyInstructionSaved: "Advisor.CompanyInstructionSaved",
  CompanyInstructionSaveFailed: "Advisor.CompanyInstructionSaveFailed",
  CompanyInstructionLoadFailed: "Advisor.CompanyInstructionLoadFailed",
  AuditSheetItemHasAttachment: "Advisor.AuditSheetItemHasAttachment",
  AuditSheetItemAttachmentCount: "Advisor.AuditSheetItemAttachmentCount",
  NoAccountSpecification: "Advisor.NoAccountSpecification",
  }
export default Advisor;